import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import { useCurrentSavedSearchId } from '~/hooks/srp/useSavedSearchApplied';

export default function useIsSavedSearchApplied() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const savedSearchId = useCurrentSavedSearchId(appliedFilters);

  return savedSearchId !== null;
}
